import { render, staticRenderFns } from "./vSeguiSolicitud.vue?vue&type=template&id=dd562474&scoped=true&"
import script from "./vSeguiSolicitud.vue?vue&type=script&lang=js&"
export * from "./vSeguiSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd562474",
  null
  
)

export default component.exports